// Forwards Klaviyo sign-up form events to the Custom Pixel (GTM lives in the pixel sandbox,
// so the storefront cannot push to its dataLayer directly).
// Based on https://help.klaviyo.com/hc/de-de/articles/115005077027

interface KlaviyoFormEventDetail {
  type?: string;
  formId?: string;
  formVersionId?: string | number;
  metaData?: Record<string, unknown>;
}

const EVENT_MAP: Record<string, string> = {
  open: "klaviyo_form_open",
  embedOpen: "klaviyo_form_open",
  submit: "klaviyo_form_submit",
  stepSubmit: "klaviyo_form_step_submit",
  redirectedToUrl: "klaviyo_form_redirect",
  close: "klaviyo_form_close",
};

let initialized = false;

const formDisplay = (detail: KlaviyoFormEventDetail): string => {
  if (detail.type === "embedOpen") return "embed";
  if (detail.type === "open") return "popup";
  if (detail.formId && document.querySelector(`.klaviyo-form-${detail.formId}`)) return "embed";
  return "popup";
};

const handleKlaviyoFormEvent = (e: Event): void => {
  const detail = (e as CustomEvent<KlaviyoFormEventDetail>).detail;
  if (!detail?.type) return;
  const eventName = EVENT_MAP[detail.type];
  if (!eventName) return;

  // Only IDs — metaData on submit contains the entered email/phone, which must not reach GA4
  const stepName = detail.metaData?.$step_name;
  // undefined (not null) so empty fields are dropped instead of reaching GA4 as "null"
  const payload = {
    form_id: detail.formId,
    form_version_id: detail.formVersionId != null ? String(detail.formVersionId) : undefined,
    form_display: formDisplay(detail),
    step_name: typeof stepName === "string" ? stepName : undefined,
  };
  try {
    window.Shopify?.analytics?.publish?.(eventName, payload);
  } catch (error) {
    console.error("Klaviyo form tracking", error);
  }
};

export const initKlaviyoFormTracking = (): void => {
  if (initialized) return;
  initialized = true;
  window.addEventListener("klaviyoForms", handleKlaviyoFormEvent);};
